
<template>
<!-- Usage
<upload name="annex" tobucket="false" @change="onFileChange($event,'annexure')" :status="statusAnnex"></upload> -->

  <div>
    <div
      class="upload"
      v-if="status"
      @dragover.prevent
      @drop="upload_file"
      @dragover="dragging"
      :class="{'dragg': dragg}"
    >
      <div class="upload-btn-text">Drag & drop files here</div>
      <div class="upload-btn-text">Or</div>
      <div class="upload-button">
        <img src="@/assets/uploadd.svg" alt />
        <label :for="name">Browse</label>
        <input
          type="file"
          name="photo"
          class="upload-photo"
          :accept="accept"
          :id="name"
          @change="uploadFile($event.target.files[0])"
        />
      </div>
    </div>
    <div class="uploading" v-if="uploading">
      <div class="uploading-container">
        <div class="upload-info">
          <div class="uploading-btn-text">Uploading</div>
          <div class="uploading-btn-text">{{ file.name }}</div>
          <div class="progress-bar">
            <div class="progress complete">
              <!-- :class="[status == 1 ? 'complete' : '']"> -->
            </div>
          </div>
          <div class="uploading-btn-text size">{{ parseInt(file.size / 1024) }}kb</div>
        </div>
        <button class="btn-secondary" @click="status=true
          uploading=false">Cancel</button>
      </div>
    </div>
    <div class="uploaded" v-if="uploaded">
      <div class="upload-container">
        <div class="row-container">
          <img src="@/assets/icon-tick.svg" />
          <div class="upload-btn-text">File uploaded</div>
          <div @click="del()" class="delete-img">
            <img src="@/assets/ic-delete.svg" />
          </div>
        </div>
        <br />
        <div class="row-container">
          <div>
            <img :src="fileType()" />
          </div>
          <div class="upload-file-text">{{ file.name}}</div>
        </div>
      </div>
    </div>
    <div class="uploaded" v-if="failed">
      <div class="upload-container">
        <div class="row-container">
          <img src="@/assets/warning_error.svg" class="errorimage" />
          <div class="upload-btn-text">File Upload Failed</div>
        </div>
        <br />
        <div class="row-container">
          <!-- <div>
              <img :src="fileType()"  />
          </div>-->
          <div class="upload-file-text">{{ file.name}}</div>
          <div class="upload-button">
            <label :for="name">Retry</label>
            <input type="file" name="photo" :id="name" class="upload-photo" @change="retry($event)" :accept="accept" />
          </div>
        </div>
        <!-- <div class="row-container">
            <div>
            
            </div>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import {
  get_axios_file_instance,
  api_variables,
  errorHandler
} from "@/apis/variables.js";

var axios_instance = get_axios_file_instance(api_variables.SERVICE_UPLOAD_LOGO);
export default {
  props: {
    accept: {
      type: String,
      default: ''
    },
    maxSize: {
      type: Number,
      default: 5242880
    },
    name:{
      type: String,
      default: 'upload'
    },
    tobucket:{
      type:Boolean,
      default:true
    }
    // status:{
    //   type: Number,
    //    default: 0
    // }
  },
  data() {
    return {
      // status 0 for notUploaded
      // status 1 for uploading
      // status 2 for uploaded
      file: null,
      status: true,
      uploading: false,
      uploaded: false,
      failed: false,
      dragg: false,
      pdfPattern: "([a-zA-Z0-9s_\\.-:])+(.pdf)$",
      xlsPattern: "([a-zA-Z0-9s_\\.-:])+(.xls|.xlsx)$",
      imgPattern: "([a-zA-Z0-9s_\\.-:])+(.png|.jpg|.jpeg)$"
    };
  },
  activated() {
    this.uploading = false;
    this.uploaded = false;
    this.failed = false;
    this.status = true;
  },
  methods: {
    fileType() {
      if (this.file.type == "xls") {
        //console.log(this.getFileType(this.file.name));
        return require("@/assets/excel.svg");
      } else {
        if (this.file.type == "pdf") {
          //console.log(this.getFileType(this.file.name));
          return require("@/assets/pdf.svg");
        } else {
          return require("@/assets/image.svg");
        }
      }
    },
    retry(event) {
      this.failed = false;
      this.uploadFile(event.target.files[0]);
    },
    upload_file(e) {
      e.stopPropagation();
      e.preventDefault();
      this.uploadFile(e.dataTransfer.files[0]);
    },
    dragging(e) {
      // //console.log('dragging',e.target)
      // //console.log('dragging',e.bubbles)
      this.dragg = true;
    },
    async uploadFile(uploadFile) {
      this.dragg = false;
       //console.log('uploadfile',uploadFile.type)
      
       if(uploadFile.type == ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet","application/pdf"]){
            this.$emit('uploadTemplate',uploadFile);
            return;
        }

      if (uploadFile.name)
        if (uploadFile.size > parseInt(this.maxSize)) {
          this.$emit("bigFileSize");
          //console.log("File size too big!");
        } else {
          this.uploading = true;
          this.status = false;
          this.file = uploadFile;
          let formData = new FormData();
          formData.append("file", uploadFile);
          // this.$emit('change', uploadFile);

          if(!this.tobucket){
            this.$emit('change',uploadFile)
            this.uploading=false;
            this.uploaded=true;
          }else{
           //console.log("server post", uploadFile);
          // multipart
          try {
            let res = await axios_instance.post("", formData);
            if (res.data.status) {
              //console.log("SUCCESS!!", res);
              this.uploaded = true;
              this.uploading = false;
              //console.log("status!!", this.status);
              this.$emit("change", res);
            }
          } catch (error) {
            this.uploading = false;
            this.failed = true;
            this.status = false;
            //console.log("FAILURE!!", err);
          }
          // After upload change status to 2
          // this.status += this.status;
        }
        }
    },
    getFileType(filename) {
      if (new RegExp(this.imgPattern).test(filename)) {
        return "@/assets/image.svg";
      } else if (new RegExp(this.xlsPattern).test(filename)) {
        return "@/assets/excel.svg";
      } else if (new RegExp(this.pdfPattern).test(filename)) {
        return "@/assets/pdf.svg";
      } else {
        return "";
      }
    },
    del() {
      this.$emit('deleteFile', null)
      this.status = true;
      this.uploaded = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
.dragg {
  background-color: red;
  opacity: 0.4;
}
.upload {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(to right, #979797 10px, rgba(255, 255, 255, 0) 0%),
    linear-gradient(#979797 10px, rgba(255, 255, 255, 0) 0%),
    linear-gradient(to right, #979797 10px, rgba(255, 255, 255, 0) 0%),
    linear-gradient(#979797 10px, rgba(255, 255, 255, 0) 0%);
  background-position: top, right, bottom, left;
  background-repeat: repeat-x, repeat-y;
  background-size: 20px 1px, 1px 20px;
  width: 300px;
  height: 140px;
  padding: 25px;
}
.delete-img {
  margin-left: auto;
}
.uploading {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(
      to right,
      $color-secondary 10px,
      rgba(255, 255, 255, 0) 0%
    ),
    linear-gradient($color-secondary 10px, rgba(255, 255, 255, 0) 0%),
    linear-gradient(to right, $color-secondary 10px, rgba(255, 255, 255, 0) 0%),
    linear-gradient($color-secondary 10px, rgba(255, 255, 255, 0) 0%);
  background-position: top, right, bottom, left;
  background-repeat: repeat-x, repeat-y;
  background-size: 20px 1px, 1px 20px;
  width: 300px;
  height: 140px;
  padding: 10px;
  .uploading-container {
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    background-color: #ffffff;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
.uploaded {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(
      to right,
      $color-secondary 10px,
      rgba(255, 255, 255, 0) 0%
    ),
    linear-gradient($color-secondary 10px, rgba(255, 255, 255, 0) 0%),
    linear-gradient(to right, $color-secondary 10px, rgba(255, 255, 255, 0) 0%),
    linear-gradient($color-secondary 10px, rgba(255, 255, 255, 0) 0%);
  background-position: top, right, bottom, left;
  background-repeat: repeat-x, repeat-y;
  background-size: 20px 1px, 1px 20px;
  width: 300px;
  height: 140px;
  padding: 10px;
  .upload-container {
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    background-color: #ffffff;
    width: 100%;
    height: 100%;
    display: flex;
    padding: 20px;
    flex-direction: column;
    align-items: center;
  }
}
.upload-button {
  display: flex;
  align-items: center;
  height: 30px;
  margin-top: 10px;
  label {
    cursor: pointer;
    border: 1px solid #5d409f;
    border-radius: 4px;
    padding: 5px 15px 5px 15px;
    font-size: 15px;
    color: #5d409f;
  }
  .upload-photo {
    opacity: 0;
    position: absolute;
    z-index: -1;
  }
  img {
    height: 27px;
    width: 27px;
    margin-right: 8px;
  }
}

.upload-btn-text {
  color: #6c6c6c;
  font-size: $font-size-small;
  margin-top: 5px;
}
.uploading-btn-text {
  color: #6c6c6c;
  font-size: $font-size-small;
  margin-top: 2px;
  &.size {
    float: right;
  }
}
.btn-secondary {
  background-color: white;
  color: $color-secondary;
  border-radius: 4px;
  border: 1px solid $color-secondary;
  height: 30px;
  padding: 0px 20px;
  font-size: $font-size-small;
  width: auto;
  margin-top: auto;
  margin-bottom: 10px;
}
.progress-bar {
  width: 200px;
  border: 0.5px solid $color-secondary;
  height: 4px;
  background: white;
  .progress {
    transition: width 5s;
    background: $color-secondary;
    width: 0%;
    height: 4px;
    &.complete {
      width: 100%;
    }
  }
}
.upload-file-text {
  color: #6c6c6c;
  font-size: $font-size-small;
  margin-top: 10px;
  text-decoration: underline;
}

.upload-info {
  margin-top: auto;
  padding-left: 20px;
  padding-top: 15px;
}

.image {
  background: url("../assets/image.svg") no-repeat fixed;
  background-size: 36px 36px;
}

.excel {
  background: url("../assets/excel.svg") no-repeat fixed;
  background-size: 36px 36px;
}

.pdf {
  background: url("../assets/pdf.svg") no-repeat fixed;
  background-size: 36px 36px;
}
.errorimage {
  width: 10%;
}
</style>
